import { Outlet, useNavigate } from "@tanstack/react-router"
import { Button } from "design-system/atoms/Button"
import { Plus, SearchIcon } from "lucide-react"
import { useQRsQuery } from "modules/campaigns/hooks/sections/qr/useQRsQuery"
import { Pagination } from "modules/shared/components/Pagination"
import { SearchQuery } from "modules/shared/components/SearchQuery"
import { usePagination } from "modules/shared/hooks/usePagination"
import { useSearchQuery } from "modules/shared/hooks/useSearchQuery"
import { useTranslation } from "react-i18next"
import { Route as QRsListRoute, SearchSchema } from "routes/_base/_auth/settings/channels/qr/route"
import { QRsTable } from "./QRsTable"

const ITEMS_PER_PAGE = 20

export const QRs = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  const search = QRsListRoute.useSearch()
  const { page, totalPages, setPage, setCount, count } = usePagination({
    search,
    fullPath: QRsListRoute.fullPath,
    total: ITEMS_PER_PAGE,
  })

  const { query, setQuery } = useSearchQuery({
    search,
    fullPath: QRsListRoute.fullPath,
    onSearchQueryChange: () => setPage(1),
  })

  const { data, isPending } = useQRsQuery({
    query: { query, page, total: ITEMS_PER_PAGE },
    onSuccess: (data) => setCount(data.pageInfo.count),
  })

  const handleCreateQRButton = async () => {
    navigate({ to: "/settings/channels/qr/create", search: SearchSchema.parse(search) })
  }

  return (
    <>
      <div className="flex flex-col gap-2">
        <div className="flex flex-col sm:flex-row gap-2 justify-end">
          <div className="flex flex-col sm:flex-row gap-2 w-full">
            <SearchQuery
              placeholder={t("campaigns.templates.qr.filters.searchPlaceholder")}
              setQuery={setQuery}
              defaultValue={query}
              icon={SearchIcon}
            />
          </div>
          <Button variant="default" onClick={handleCreateQRButton} className="min-w-fit h-full">
            <span>
              <Plus className="size-4" strokeWidth={2} />
            </span>
            <span>{t("campaigns.templates.qr.actions.create")}</span>
          </Button>
        </div>
        <div className="flex flex-col gap-4">
          <QRsTable data={data} isPending={isPending} />
          <Pagination
            currentPage={page}
            totalPages={totalPages}
            onPageChange={setPage}
            count={count}
          />
        </div>
      </div>
      <Outlet />
    </>
  )
}
